import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=31e3950c&scoped=true&"
import script from "./GroupPanel.vue?vue&type=script&lang=js&"
export * from "./GroupPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3950c",
  null
  
)

export default component.exports